import { Component, Input, forwardRef, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs';

import { AbstractFormFieldComponent } from '../../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { BriefingSortByEnum } from '../../enums/briefing-sort-by.enum';
import { getAutomaticBlockSortOptions } from '../../models/briefing-sort-by-options.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { BriefingSortByFieldModel } from '../../models/briefing-sort-by.field.model';
import { SearchCriteriaSortFieldEnum } from '../../../../api/mentions/enum/search-criteria-sort-field.enum';
import { SortOrderEnum } from '../../../../api/shared/enums/sort-order.enum';
import { MentionSearchCriteriaModel } from '../../../Shared/models/mention-search-criteria.model';
import { BriefingConfigService } from '@Common/MonitorShared/services/briefing-config.service';

@Component({
    selector: 'agpr-briefing-sort-by-field',
    templateUrl: './briefing-sort-by-field.component.html',
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => BriefingSortByFieldComponent)
        }
    ],
    standalone: false
})
export class BriefingSortByFieldComponent extends AbstractFormFieldComponent implements OnInit {

    @Input() declare field: BriefingSortByFieldModel;
    @Input() declare value: MentionSearchCriteriaModel;

    sortOptions: {label: string; value: BriefingSortByEnum}[] = [];
    sortByDropdown: DropdownOptionModel = new DropdownOptionModel();
    sortBy: BriefingSortByEnum;

    private subscriptions: Subscription[] = [];

    constructor(
        private briefingConfigService: BriefingConfigService,
    ) {
        super();
    }

    ngOnInit() {
        this.sortOptions = getAutomaticBlockSortOptions();

        switch (this.value.sortField) {
            case SearchCriteriaSortFieldEnum.published:
                if (this.value.sortOrder === SortOrderEnum.descending) {
                    this.sortBy = BriefingSortByEnum.PUBLISHED_DATE_NEWEST;
                } else if (this.value.sortOrder === SortOrderEnum.ascending) {
                    this.sortBy = BriefingSortByEnum.PUBLISHED_DATE_OLDEST;
                }
                break;
            case SearchCriteriaSortFieldEnum.audience_reach:
                if (this.value.sortOrder === SortOrderEnum.descending) {
                    this.sortBy = BriefingSortByEnum.POTENTIAL_AUDIENCE_MOST;
                } else if (this.value.sortOrder === SortOrderEnum.ascending) {
                    this.sortBy = BriefingSortByEnum.POTENTIAL_AUDIENCE_LEAST;
                }
                break;
            case SearchCriteriaSortFieldEnum.domainAuthority:
                this.sortBy = BriefingSortByEnum.DOMAIN_AUTHORITY;
                break;
            case SearchCriteriaSortFieldEnum.engagement_total:
                this.sortBy = BriefingSortByEnum.ENGAGEMENT_MOST;
                break;
        }

        this.subscriptions.push(
            this.briefingConfigService.getConfig().pipe(filter(x => !!x)).subscribe(config => {
                if (config.hasEngagementUpdates) {
                    this.sortOptions.push({
                        label: 'Briefings.input.sortMentionsBy.engagementMost',
                        value: BriefingSortByEnum.ENGAGEMENT_MOST
                    });
                }

                if (this.sortBy) {
                    this.sortByDropdown = this.sortOptions.find(x => x.value === this.sortBy);
                } else {
                    this.sortByDropdown = this.sortOptions[0];
                    this.sortBy = this.sortOptions[0].value;
                }
            })
        );
    }

    onSortByChanged(sortBy: BriefingSortByEnum): void {
        this.sortBy = sortBy;

        switch (sortBy) {
            case BriefingSortByEnum.PUBLISHED_DATE_NEWEST:
                this.value.sortField = SearchCriteriaSortFieldEnum.published;
                this.value.sortOrder = SortOrderEnum.descending;
                break;
            case BriefingSortByEnum.PUBLISHED_DATE_OLDEST:
                this.value.sortField = SearchCriteriaSortFieldEnum.published;
                this.value.sortOrder = SortOrderEnum.ascending;
                break;
            case BriefingSortByEnum.POTENTIAL_AUDIENCE_MOST:
                this.value.sortField = SearchCriteriaSortFieldEnum.audience_reach;
                this.value.sortOrder = SortOrderEnum.descending;
                break;
            case BriefingSortByEnum.POTENTIAL_AUDIENCE_LEAST:
                this.value.sortField = SearchCriteriaSortFieldEnum.audience_reach;
                this.value.sortOrder = SortOrderEnum.ascending;
                break;
            case BriefingSortByEnum.DOMAIN_AUTHORITY:
                this.value.sortField = SearchCriteriaSortFieldEnum.domainAuthority;
                this.value.sortOrder = SortOrderEnum.descending;
                break;
            case BriefingSortByEnum.ENGAGEMENT_MOST:
                this.value.sortField = SearchCriteriaSortFieldEnum.engagement_total;
                this.value.sortOrder = SortOrderEnum.descending;
                break;
        }

        this.changes.emit(this.value);
    }
}

